/**
 * copy from business-act/report
 * 避免引入整个包
 * 前端上报打log
 * @static
 * @param  {*} message  [log内容]
 * @param  {String|null} logLevel [log级别，默认为info, 有5个级别：'error','warning','notice','info','debug']
 * @return {void}
 *
 * @example
Report.log('初始化话页面');
Report.log({
    msg: '初始化页面',
    uid: 600019
});
Report.log('出错了', 'error');
 */

export function reportLog(message, logLevel) {
    window['dedog'] &&
        window['dedog'].log({
            //必填。这里是5个级别：'error','warning','notice','info','debug',对应uls查询列表中LogLevel那一列
            level: logLevel || 'info',
            message: JSON.stringify(message)
        });
}

/**
 * 获取异常的具体信息 兼容 Error 和 object 类型
 * @param  {any} err 上报信息
 * @param  {any} split 分割符号
 * @return {string} 异常信息
 */
export function errStr(err, split = '\n') {
    if (err instanceof Error) {
        const { code = 0, name = 'Error', message = '', stack = '' } = err;
        return `${split}code:${code}${split}name:${name}${split}message:${message}${split}stack:${stack}${split}`;
    } else {
        return JSON.stringify(err);
    }
}
